import React, { FC } from 'react';
import { Rocket } from './Rocket';
import { Link } from './Link';
import { DeviceType } from './App';
import { BlinkTraffic } from 'effect-apis-client';

interface Props {
    blinkTraffic: BlinkTraffic;
    deviceType: DeviceType;
}

export const BlinkPanel: FC<Props> = ({ deviceType, blinkTraffic }) => {
    if (blinkTraffic.type === 'no_traffic') {
        return null;
    } else {
        return (
            <div className="flex flex-col p-8">
                <div className="flex items-center space-x-16">
                    <Rocket className="h-80 w-80 sm:h-40 sm:w-40" />
                    <div className="flex flex-col">
                        <p>Denne annonsen har fått ekstra effekt fra {blinkTraffic.productName}</p>
                        {blinkTraffic.type === 'increased_traffic' && (
                            <div className="hidden sm:flex sm:flex-row sm:space-x-4">
                                <p className="mb-8">
                                    <strong>+{blinkTraffic.increasedTraffic}%</strong> flere klikk enn vanlig
                                </p>
                                <Link
                                    deviceType={deviceType}
                                    page="objectpage"
                                    link={blinkTraffic.partnerLink}
                                    partnerName={blinkTraffic.partnerName}
                                />
                            </div>
                        )}
                        {blinkTraffic.type === 'little_traffic' && (
                            <Link
                                deviceType={deviceType}
                                page="objectpage"
                                link={blinkTraffic.partnerLink}
                                partnerName={blinkTraffic.partnerName}
                            />
                        )}
                    </div>
                </div>
                {blinkTraffic.type === 'increased_traffic' && (
                    <div className="flex flex-col sm:hidden">
                        <p className="mb-8">
                            <strong>+{blinkTraffic.increasedTraffic}%</strong> flere klikk enn vanlig
                        </p>
                        <Link
                            deviceType={deviceType}
                            page="objectpage"
                            link={blinkTraffic.partnerLink}
                            partnerName={blinkTraffic.partnerName}
                        />
                    </div>
                )}
            </div>
        );
    }
};
